/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 验证账号
 */
export function validUsername(str) {
  return /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/.test(str)
}
// export function validUsernameEl(rule, val, cb) {
//   if (validUsername(val)) {
//     checkAccount(1, val).then(() => {
//       cb()
//     }).catch(() => {
//       cb(new Error('该手账号已经存在!'))
//     })
//   } else {
//     cb(new Error('长度为5-15个字符;以字母开头;可以包含字母、数字、_'))
//   }
// }

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp|http):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  console.log('validEmail', reg.test(email))
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 验证手机号
 */
export function validPhone(str) {
  // return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(str)
  return /^1\d{10}$/.test(str)
}
/**
 * 验证手机号是否注册(暂无接口)
 */
// export function validPhoneEl(rule, val, cb) {
//   if (isEmpty(val)) {
//     cb()
//     return
//   }
//   if (validPhone(val)) {
//     checkAccount(2, val).then(() => {
//       cb()
//     }).catch(() => {
//       cb(new Error('该手机号已经存在!'))
//     })
//   } else {
//     cb(new Error('请输入正确的手机号'))
//   }
// }

/**
 * 验证密码
 */
export function validPassword(str) {
  // 包含数字、大小写字母、特殊字符,长度8-20位
  return /^(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?])[\dA-Za-z!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?]{8,20}$\S*$/.test(
    str
  )
}

export function validPasswordEl(rule, val, cb) {
  // 长度8-20位，包含数字、大小写字母、特殊字符
  if (val.length < 1) {
    return cb(new Error('密码不能为空'))
  }
  if (!/^([\dA-Za-z!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?]{1,})$/.test(val)) {
    return cb(new Error('有非法字符'))
  }
  if (!/(?=\S*\d)/.test(val)) {
    return cb(new Error('应包含数字'))
  }
  if (!/(?=\S*[A-Z])/.test(val)) {
    return cb(new Error('应包含大写字母'))
  }
  if (!/(?=\S*[a-z])/.test(val)) {
    return cb(new Error('应包含小写字母'))
  }
  if (!/(?=\S*[!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?])/.test(val)) {
    return cb(new Error('应包含特殊字符'))
  }
  if (!/^(\S{8,20})$/.test(val)) {
    return cb(new Error('密码长度为8~20'))
  }
  return cb()
}
